let ie11: boolean | undefined;

export function isIE11() {
  if (ie11 === undefined) {
    ie11 = /Trident.*rv[ :]*11\./.test(window.navigator.userAgent);
  }
  return ie11;
}
